import axios from 'axios'

import { addAuthTokenToRequest } from './utils/addAuthTokenToRequest'

const reportingToolAPI = axios.create({
  baseURL: process.env.VUE_APP_REPORT_TOOL,
  // baseURL: 'http://localhost:8000',
})

reportingToolAPI.interceptors.request.use(addAuthTokenToRequest)

export default reportingToolAPI
